let pythonJson = [{
    "filename":"helloWorld",
    "content":"# 请在下方输入你的Python代码"
}]

function getProtocol() {
    return window.location.protocol
}

function getBaseURL() {
    const protocol = window.location.protocol
    return `${protocol}//www.wancode.net`
}

export default {
    pythonJson,
    getProtocol,
    getBaseURL
}
